import React from 'react';

// Plain text with web links made clickable. Only http/https URLs become links (never javascript:
// and the like), and trailing punctuation stays outside the link. Everything else stays text, so
// nothing from the message is ever interpreted as markup.
const URL_PATTERN = /https?:\/\/[^\s<>"]+/g;

export default function linkify(text) {
  if (!text) return text;
  const parts = [];
  let last = 0;
  let match;
  URL_PATTERN.lastIndex = 0;
  while ((match = URL_PATTERN.exec(text)) !== null) {
    const raw = match[0];
    const url = raw.replace(/[.,;:!?)'\]]+$/, '');
    if (match.index > last) parts.push(text.slice(last, match.index));
    parts.push(<a key={`${match.index}-${url}`} href={url} target="_blank" rel="noopener noreferrer">{url}</a>);
    last = match.index + url.length;
    URL_PATTERN.lastIndex = last;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
